import type { Transformation } from '@imagekit/javascript';
import { memo } from 'react';

import { buildSrc } from '@/integrations/image-kit';

export interface ProfileNonToxicIconProps {
  className?: string;
  tier: number;
  transformations?: Transformation[];
}

export const ProfileNonToxicIcon = memo(function ProfileNonToxicIcon({
  tier,
  className,
  transformations,
  ...props
}: ProfileNonToxicIconProps) {
  const imagePath = `/duos-storage/non-toxic/non-toxic-${tier.toString()}.png`;
  const imageUrl = buildSrc({
    src: imagePath,
    transformation: [{ dpr: 2 }, ...(transformations ?? [])],
  });

  return (
    <img
      src={imageUrl}
      alt={`Non-toxic tier ${tier.toString()}`}
      className={className}
      {...props}
    />
  );
});
